import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const DeleteFamilyEnrollmentMutation = graphql.persisted(
  "DeleteFamilyEnrollment",
  graphql(`
    mutation DeleteFamilyEnrollment($familyEnrollmentId: ID!) {
      deleteFamilyEnrollment(input: {familyEnrollmentId: $familyEnrollmentId}) {
        success
        deletedStudentCount
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { DeleteFamilyEnrollmentMutation };

export function useDeleteFamilyEnrollment() {
  return useMutation(DeleteFamilyEnrollmentMutation);
}
